export const RulesVB = {
  MAX_CHILDREN_PER_ADULT: 'maxchildrenperadult',
  MAX_INFANT_PER_ADULT: 'maxinfantperadult',
  MAX_INFANT_CHILDREN_PER_ADULT: 'maxinfantandchildrenperadult'
};

const parseRule = (str) => {
  const params = str.split(':');
  const response = { rule: '', param: -1 };
  if (params.length === 2) {
    response.rule = params[0]?.toLowerCase();
    response.param = Number(params[1]);
  } else {
    if (params[0]) {
      response.rule = params[0]?.toLowerCase();
      response.param = 1;
    }
  }
  return response;
};

const getPassengerOption = (passengers, name) => {
  const index = passengers.options.findIndex((item) => item.name === name);
  return { index, ...passengers.options[index] };
};

export const evaluateRules = (rules, passengers) => {
  const parsedRules = rules.map(parseRule);

  const adults = getPassengerOption(passengers, 'passenger1');
  const children = getPassengerOption(passengers, 'passenger2');
  const infant = getPassengerOption(passengers, 'passenger3');
  const infantSeat = getPassengerOption(passengers, 'passenger4');
  const filipinoWorker = getPassengerOption(passengers, 'passenger5');

  const youth = getPassengerOption(passengers, 'passenger7').enabled
    ? getPassengerOption(passengers, 'passenger7')
    : getPassengerOption(passengers, 'passenger6');

  return (state, action, index) => {
    if (!Number.isInteger(index)) {
      // console.error('**NOT_VALID_INDEX**');
      return { valid: true, ruleActions: () => {} };
    }
    let result = true;

    const evaluateRule = (parsedRule) => {
      //Each infant must be accompanied by 1 adult (in pair).
      if (action === 'ADD' && index === infant.index) {
        result =
          result &&
          state.count[index] + state.count[infantSeat.index] + 1 <=
            state.count[adults.index] + state.count[filipinoWorker.index];
      }
      if (action === 'ADD' && index === infantSeat.index) {
        result =
          result &&
          state.count[index] + state.count[infant.index] + 1 <=
            state.count[adults.index] + state.count[filipinoWorker.index];
      }
      //rule infantsByAdult
      if (parsedRule.rule === RulesVB.MAX_INFANT_PER_ADULT) {
        if (action === 'ADD' && index === infant.index) {
          result =
            result &&
            state.count[index] + 1 <=
              parsedRule.param * state.count[adults.index] + state.count[filipinoWorker.index];
        }
        if (action === 'ADD' && index === infantSeat.index) {
          result =
            result &&
            state.count[index] + 1 <=
              parsedRule.param * state.count[adults.index] + state.count[filipinoWorker.index];
        }
      }
      //rule maxChildren
      if (parsedRule.rule === RulesVB.MAX_CHILDREN_PER_ADULT) {
        if (action === 'ADD' && index === children.index) {
          result =
            result &&
            state.count[index] +
              state.count[adults.index] +
              state.count[filipinoWorker.index] +
              state.count[youth.index] +
              state.count[infantSeat.index] +
              1 <=
              parsedRule.param;
        }
        if (action === 'ADD' && index === adults.index) {
          result =
            result &&
            state.count[index] +
              state.count[children.index] +
              state.count[filipinoWorker.index] +
              state.count[youth.index] +
              state.count[infantSeat.index] +
              1 <=
              parsedRule.param;
        }
        if (action === 'ADD' && index === filipinoWorker.index) {
          result =
            result &&
            state.count[index] +
              state.count[adults.index] +
              state.count[children.index] +
              state.count[youth.index] +
              state.count[infantSeat.index] +
              1 <=
              parsedRule.param;
        }
        if (action === 'ADD' && index === youth.index) {
          result =
            result &&
            state.count[index] +
              state.count[adults.index] +
              state.count[children.index] +
              state.count[filipinoWorker.index] +
              state.count[infantSeat.index] +
              1 <=
              parsedRule.param;
        }
        if (action === 'ADD' && index === infantSeat.index) {
          result =
            result &&
            state.count[index] +
              state.count[adults.index] +
              state.count[children.index] +
              state.count[filipinoWorker.index] +
              state.count[youth.index] +
              1 <=
              parsedRule.param;
        }
      }
      //rule maxInfantAndChildrenPerAdult
      if (parsedRule.rule === RulesVB.MAX_INFANT_CHILDREN_PER_ADULT) {
        if (action === 'ADD' && index === adults.index) {
          result =
            result &&
            state.count[children.index] + state.count[infant.index] + 1 <= parsedRule.param;
        }
        if (action === 'ADD' && index === infant.index) {
          result =
            result &&
            state.count[children.index] + state.count[infant.index] + 1 <= parsedRule?.param;
        }
        if (action === 'ADD' && index === children.index) {
          result =
            result &&
            state.count[children.index] + state.count[infant.index] + 1 <= parsedRule.param;
        }
      }
    };

    parsedRules.forEach(evaluateRule);

    const ruleActions = (draft) => {
      parsedRules.forEach((parsedRule) => {
        const ruleParam = parsedRule.param;
        if (action === 'REMOVE' && index === adults.index) {
          if (parsedRule.rule === RulesVB.MAX_CHILDREN_PER_ADULT) {
            //remove the children count
            if (draft.count[children.index] > draft.count[adults.index] * ruleParam) {
              if (draft.count[children.index] - ruleParam >= 0) {
                const rest = draft.count[children.index] % ruleParam;
                if (rest === 0) {
                  draft.count[children.index] -= ruleParam;
                } else {
                  draft.count[children.index] -= rest;
                }
              }
            }
          }
          if (infantSeat.enable !== true) {
            if (parsedRule.rule === RulesVB.MAX_INFANT_PER_ADULT) {
              //remove the infant count
              if (draft.count[infant.index] > draft.count[adults.index] * ruleParam) {
                if (draft.count[infant.index] - ruleParam >= 0) {
                  const rest = draft.count[children.index] % ruleParam;
                  if (rest === 0) {
                    draft.count[infant.index] -= ruleParam;
                  } else {
                    draft.count[infant.index] -= rest;
                  }
                }
              }
            }

            if (parsedRule.rule === RulesVB.MAX_INFANT_CHILDREN_PER_ADULT) {
              const totalChildren = draft.count[children.index] + draft.count[infant.index];
              if (totalChildren > draft.count[adults.index] * ruleParam) {
                let total = draft.count[children.index] + draft.count[infant.index];
                let isYouth = true;
                while (total > draft.count[adults.index] * ruleParam) {
                  isYouth = draft.count[children.index] > draft.count[infant.index];

                  if (isYouth) {
                    if (draft.count[children.index] > 0) {
                      draft.count[children.index] -= 1;
                    }
                  } else {
                    if (draft.count[infant.index] > 0) {
                      draft.count[infant.index] -= 1;
                    }
                  }
                  total = draft.count[children.index] + draft.count[infant.index];
                }
              }
            }
          }
        }
      });
    };

    return { valid: result, ruleActions };
  };
};
